import { API } from '../Api';

// Lời nhắn giọng nói khi donate (payment-service + media-service).
// Streamer tự bật/tắt và đặt mức Ca tối thiểu; người xem ghi âm tối đa 15 giây,
// tải lên media-service trước để lấy voiceClipId rồi mới donate kèm clip đó.

export interface VoiceSetting {
  enabled: boolean;
  minCa: number;
}

export const getPublicVoiceSetting = (userId: string) =>
  API.get<VoiceSetting>('/v1/payment-service/public/creator-voice-setting', {
    params: { userId },
  }).then((r) => r.data);

export const getMyVoiceSetting = () =>
  API.get<VoiceSetting>('/v1/payment-service/donate-voice/settings/me').then((r) => r.data);

export const saveVoiceSetting = (s: VoiceSetting) =>
  API.post<VoiceSetting>('/v1/payment-service/donate-voice/settings', s).then((r) => r.data);

export interface RecentVoiceDonation {
  id: string;
  senderName: string;
  isAnonymous: boolean;
  amount: number;
  createdAt: string;
  url: string | null;
  expiresAt: string;
}

export const getRecentVoiceDonations = () =>
  API.get<RecentVoiceDonation[]>('/v1/payment-service/donate-voice/recent').then((r) => r.data);

export interface UploadedVoiceMessage {
  id: string;
  url: string;
  durationMs: number;
}

export const uploadVoiceMessage = (blob: Blob, mime: string) => {
  const ext = mime.includes('mp4') ? 'mp4' : mime.includes('ogg') ? 'ogg' : 'webm';
  const form = new FormData();
  form.append('file', blob, `voice-message.${ext}`);
  return API.post<UploadedVoiceMessage>('/v1/media-service/VoiceMessages/upload', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};
